export const ModelerReadOnlyExtensionModule = {
  __init__: ['pathwaysContextPadProvider', 'move','bendpoints', 'pathwaysPaletteProvider'],
  pathwaysContextPadProvider: ['type', Object],
  move: ['type', Object],
  bendpoints: ['type', Object],
  pathwaysPaletteProvider: ['type', Object]
};
